import { createBrowserHistory, createHashHistory } from "history";
import { isElectron } from "../utils";

const history = isElectron() ? createHashHistory() : createBrowserHistory();

export default history;
